module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-21.edc546f2.png";